import React, { useCallback, useEffect, useState } from "react";
import Loader from "../../components/loader";
import NoData from "../../components/noData";
import { useNCallContext } from "../../context/ncall-context";
import Table from "../../components/table";
import { useNavigate } from "react-router-dom";

const Employees = () => {
  const { state, getEmployees } = useNCallContext();
  const { employees } = state;

  const navigate = useNavigate();
  useEffect(() => {
    if (localStorage.getItem("logged-in-as") == "client") {
      navigate("/client");
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("sort", JSON.stringify({ id: "ID", desc: false }));
    getEmployees();
  }, []);

  const columns = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "ID",
      },
      {
        Header: "Alias",
        accessor: "Alias",
      },
      {
        Header: " First Name",
        accessor: "Firstname",
      },
      {
        Header: "Last Name",
        accessor: "Lastname",
      },
      {
        Header: "Status ID",
        accessor: "StatusID",
      },
    ],
    []
  );
  const actions = [];

  if (state.loading) return <Loader />;

  return (
    <div className="">
      <div className="sm:flex sm:items-center flex-row gap-3 justify-between items-cente">
        <div className="sm:flex-auto ">
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            Employees
          </h1>
        </div>
      </div>
      {employees.length === 0 ? (
        <NoData message={"You don't have any employees."} />
      ) : (
        <div className="mt-8 flow-root">
          <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
              <Table
                columns={columns}
                data={state?.employees}
                actions={actions}
                name="employees"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Employees;
